(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dealer-info-preview"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.rfn-dealer [data-video]').forEach(function(button){
  button.addEventListener('click',function(){
    var frame=document.createElement('iframe');
    frame.src='https://www.youtube-nocookie.com/embed/'+button.dataset.video+'?autoplay=1&rel=0';
    frame.title=button.dataset.title;
    frame.allow='autoplay; encrypted-media; picture-in-picture';
    frame.allowFullscreen=true;
    frame.referrerPolicy='strict-origin-when-cross-origin';
    button.parentElement.classList.add('is-playing');
    button.replaceWith(frame);
    frame.focus();
  },{once:true});
});


/* Enhance the same content on phones, restoring original nodes on desktop. */
(function(){
  document.querySelectorAll('.rfn-dealer[data-mobile-more]').forEach(function(root){
    if(root.dataset.mobileReady)return;
    root.dataset.mobileReady='true';
    var media=window.matchMedia('(max-width:799px)');
    var undo=[];
    function fold(parent,nodes,summaryNode,className){
      if(!nodes.length)return;
      var details=document.createElement('details');
      details.className=className;
      var summary=document.createElement('summary');
      var body=document.createElement('div');
      var all=summaryNode?[summaryNode].concat(nodes):nodes;
      var markers=all.map(function(node){var marker=document.createComment('mobile fold');node.before(marker);return {node:node,marker:marker};});
      all[0].before(details);
      if(summaryNode)summary.appendChild(summaryNode);
      else summary.textContent=root.dataset.mobileMore;
      details.appendChild(summary);
      nodes.forEach(function(node){body.appendChild(node);});
      details.appendChild(body);
      undo.push(function(){markers.forEach(function(item){item.marker.replaceWith(item.node);});details.remove();});
      return body;
    }
    function update(){
      undo.reverse().forEach(function(restore){restore();});
      undo=[];
      if(!media.matches)return;
      [['.hero-copy','p:not(.intro):not(.eyebrow)'],['.mission-copy','p:not(.intro)'],['.brand-copy','p:not(.intro):not(.eyebrow)']].forEach(function(config){
        var parent=root.querySelector(config[0]);
        fold(parent,Array.from(parent.children).filter(function(node){return node.matches(config[1]);}),null,'mobile-more');
      });
      root.querySelectorAll('.comparison').forEach(function(article){
        var heading=article.querySelector('h3');
        var nodes=Array.from(article.children).filter(function(node){return node!==heading&&!node.matches('.eyebrow,.comparison-takeaway');});
        var body=fold(article,nodes,heading,'mobile-comparison');
        var table=body.querySelector(':scope > table');
        if(table){
          var scroll=document.createElement('div');
          scroll.className='mobile-table-scroll';
          scroll.tabIndex=0;
          scroll.setAttribute('role','region');
          scroll.setAttribute('aria-label',table.querySelector('caption').textContent);
          table.before(scroll);scroll.appendChild(table);
          undo.push(function(){scroll.replaceWith(table);});
        }
      });
      root.querySelectorAll('.support-grid article').forEach(function(article){
        fold(article,Array.from(article.children).filter(function(node){return node.tagName==='P';}),article.querySelector('h3'),'mobile-support');
      });
      var warranty=root.querySelector('.warranty');
      var wasOpen=warranty.open;
      warranty.open=false;
      undo.push(function(){warranty.open=wasOpen;});
    }
    update();
    media.addEventListener('change',update);
    function revealHash(){
      if(!media.matches||!window.location.hash)return;
      var target=document.getElementById(window.location.hash.slice(1));
      if(!target||!root.contains(target))return;
      var fold=target.querySelector('.mobile-comparison');
      if(fold)fold.open=true;
    }
    revealHash();
    window.addEventListener('hashchange',revealHash);
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() { super(); }
  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always' ||
      this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.setHeaderHeight();
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    if (this.headerIsAlwaysSticky) { this.header.classList.add('shopify-section-header-sticky'); }
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search'); /* ok even if search removed */
    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.createObserver();
  }
  setHeaderHeight() {
    const rollingAnnouncement =
      this.header?.closest('.section-header')?.previousElementSibling?.querySelector('.rolling-announcement');
    const announcementHeight = rollingAnnouncement ? rollingAnnouncement.offsetHeight : 0;

    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    document.documentElement.style.setProperty(
      '--header-overlay-offset',
      `${this.header.offsetHeight + announcementHeight}px`
    );
  }
  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }
  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });
    observer.observe(this.header);
  }
  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }
    this.currentScrollTop = scrollTop;
  }
  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }
  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }
  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach((disclosure) => disclosure.close());
  }
  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    if (this.searchModal && this.searchModal.close) this.searchModal.close(false);
  }
}
customElements.define('sticky-header', StickyHeader);

const homeOverlayHeader = document.querySelector('.header-wrapper--home-overlay');
if (homeOverlayHeader && homeOverlayHeader.dataset.overlayHeaderBound !== 'true') {
  const headerSection = homeOverlayHeader.closest('.section-header');
  const announcementBar = headerSection?.previousElementSibling?.querySelector('.rolling-announcement');
  const updateAnnouncementHeight = () => {
    document.documentElement.style.setProperty(
      '--home-announcement-height',
      `${announcementBar?.offsetHeight || 0}px`
    );
  };
  const updateOverlayHeader = () => {
    headerSection?.classList.toggle('header-overlay--scrolled', window.scrollY > 32);
  };

  homeOverlayHeader.dataset.overlayHeaderBound = 'true';
  updateAnnouncementHeight();
  updateOverlayHeader();
  window.addEventListener('scroll', updateOverlayHeader, { passive: true });
  window.addEventListener('resize', updateAnnouncementHeight);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rfn-first-bike"] && !Shopify.designMode) return;
  try {
    
function initFirstBike(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const slides=[...root.querySelectorAll('[data-slide]')],thumbs=[...root.querySelectorAll('[data-index]')];
  let index=0;
  const show=(next)=>{if(!slides.length)return;index=(next+slides.length)%slides.length;slides.forEach((slide,i)=>slide.hidden=i!==index);thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===index)));root.querySelector('[data-current]')?.replaceChildren(String(index+1));};
  root.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>show(index+Number(button.dataset.direction))));
  thumbs.forEach(button=>button.addEventListener('click',()=>show(Number(button.dataset.index))));
  const stage=root.querySelector('.fb-stage');
  let startX=0,startY=0;
  stage?.addEventListener('touchstart',event=>{startX=event.changedTouches[0].clientX;startY=event.changedTouches[0].clientY;},{passive:true});
  stage?.addEventListener('touchend',event=>{const x=event.changedTouches[0].clientX-startX,y=event.changedTouches[0].clientY-startY;if(Math.abs(x)>55&&Math.abs(x)>Math.abs(y))show(index+(x<0?1:-1));},{passive:true});
  const variants=JSON.parse(root.querySelector('[data-fb-variants]').textContent),images=JSON.parse(root.querySelector('[data-fb-images]').textContent);
  root.querySelector('[data-variant]')?.addEventListener('change',event=>{
    const variant=variants.find(v=>String(v.id)===event.target.value);if(!variant)return;
    root.querySelector('[data-price]').textContent=variant.price;
    root.querySelector('[data-add]').disabled=!variant.available;
    root.querySelector('[data-add-label]').textContent=root.querySelector(variant.available?'[data-available-label]':'[data-sold-label]').textContent;
    const imageIndex=images.indexOf(variant.image);if(imageIndex>=0)show(imageIndex);
    const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
  });
}
document.querySelectorAll('[data-first-bike]').forEach(initFirstBike);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-first-bike]').forEach(initFirstBike));

  } catch(e) { console.error(e); }
})();
})();
